import vediApi from "../utils/vedi-api/vediAPI";

export interface SmsSosRequest {
  Cuil: string;
  Latitud: string;
  Longitud: string;
}

export interface SmsSosResponse {
  return: {
    cuil: string;
    enviado: boolean;
    minutosRestantes: number;
  };
  ok: boolean;
  error: string | null;
  statusCode: number;
  cookies: null;
}

export const sendEmergencySms = async (
  cuil: string,
  latitude: string,
  longitude: string,
  numeroContacto: string
): Promise<SmsSosResponse> => {
  const request: SmsSosRequest = {
    Cuil: cuil,
    Latitud: latitude,
    Longitud: longitude,
  };

  const response = await vediApi.post(
    "/v3/Usuario/SmsSosContactoEmergencia",
    request,
    {
      headers: {
        "--Numero": numeroContacto.replace(/\D/g, ""), // Remove non-numeric characters
      },
    }
  );
  return response.data;
};

const WEBVIEW_LOCATION_KEY = "webview_location";

interface WebViewLocation {
  latitude: number;
  longitude: number;
  timestamp: number;
}

if (typeof window !== "undefined") {
  window.addEventListener("message", (event) => {
    try {
      const data =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      if (data.type === "location" && data.location) {
        const location: WebViewLocation = {
          latitude: data.location.coords.latitude,
          longitude: data.location.coords.longitude,
          timestamp: Date.now(),
        };
        localStorage.setItem(WEBVIEW_LOCATION_KEY, JSON.stringify(location));
      }
    } catch (error) {
      console.error(error as unknown as Error);
    }
  });
}

const getWebViewLocation = (): WebViewLocation | null => {
  try {
    const stored = localStorage.getItem(WEBVIEW_LOCATION_KEY);
    if (stored) {
      const location: WebViewLocation = JSON.parse(stored);
      const now = Date.now();
      const fifteenMinutes = 15 * 60 * 1000;

      if (now - location.timestamp < fifteenMinutes) {
        return location;
      } else {
        localStorage.removeItem(WEBVIEW_LOCATION_KEY);
      }
    }
  } catch (error) {
    console.error("Error getting webview location:", error);
    localStorage.removeItem(WEBVIEW_LOCATION_KEY);
  }
  return null;
};

export const getCurrentPosition = (): Promise<{
  latitude: string;
  longitude: string;
}> => {
  return new Promise((resolve, reject) => {
    // First try to get location from webview
    const webviewLocation = getWebViewLocation();
    if (webviewLocation) {
      resolve({
        latitude: webviewLocation.latitude.toString(),
        longitude: webviewLocation.longitude.toString(),
      });
      return;
    }

    // Fallback to browser geolocation
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser."));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude.toString(),
          longitude: position.coords.longitude.toString(),
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000,
      }
    );
  });
};
